module.exports = __webpack_public_path__ + "static/facebook-97cd0916e44cb3438b8caa4e21560450.svg";